import { type Settings } from '@app/client';
import config from '@app/config';

const ignoreHeaders = config?.ignoreSegmentHeaders?.split(',');
const daasIgnoredHeadersSettings = ['Authorization'];

const daasProxySettings: Settings = {
    ignoreHeaders: [...daasIgnoredHeadersSettings, ...(ignoreHeaders || [])],
    credentials: 'omit',
};

const authProxySettings: Settings = {
    ignoreHeaders,
};

export const customProxySettings = {
    auth: authProxySettings,
    daas: daasProxySettings,
    daasV2: daasProxySettings,
};
